import axiosPrivate from "./axiosPrivate";

const getGestionExterno = (periodo, estado) => {
    return axiosPrivate.get("gestion-externo", {
        params: { periodo, estado }
    })
        .then(response => response.data);
};

const insertGestionExterno = (data) => {
    return axiosPrivate.post("gestion-externo", data)
        .then(response => response.data);
};

const updateGestionExterno = (data) => {
    return axiosPrivate.put("gestion-externo", data)
        .then(response => response.data);
};

const deleteGestionExterno = (data) => {
    return axiosPrivate.delete("gestion-externo", { data })
        .then(response => response.data);
};

export default {
    getGestionExterno,
    insertGestionExterno,
    updateGestionExterno,
    deleteGestionExterno
};
